import { render, staticRenderFns } from "./search-product.vue?vue&type=template&id=34b66f3b&"
import script from "./search-product.vue?vue&type=script&lang=js&"
export * from "./search-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports